import { cva } from 'class-variance-authority';

import { cn } from '@heidi/utils';

import { focusRing } from '../styles/focus-ring';

const switchVariants = cva(
  cn(
    'group peer box-content inline-flex shrink-0 cursor-pointer items-center rounded-full p-0.5 transition-colors disabled:cursor-not-allowed',
    focusRing,
    'data-[state=checked]:bg-background-switch-on data-[state=unchecked]:bg-background-switch-off data-[state=checked]:disabled:bg-background-switch-on-disabled data-[state=unchecked]:disabled:bg-background-switch-off-disabled'
  ),
  {
    variants: {
      size: {
        xs: 'h-3  min-w-[23px]',
        sm: 'h-4 min-w-8',
        md: 'h-5 min-w-10',
      },
    },
    defaultVariants: {
      size: 'md',
    },
  }
);

// Thumb rendered at hover-width; clip-path inset masks extra pixels so animating clip-path+transform stays on the compositor.
// RTL: `translate-x` and `clip-path: inset(...)` are physical (no logical variant), so each LTR rule is paired with an
// `rtl:` companion that mirrors the sign / swaps the masked edge. Mirrors the pattern used by Sheet (see sheet.styles.ts).
const thumbVariants = (size: 'xs' | 'sm' | 'md' | null | undefined) => {
  switch (size) {
    case 'xs':
      return cn(
        'h-3 w-[14px]',
        'data-[state=checked]:translate-x-[9px] data-[state=checked]:rtl:translate-x-[-9px]',
        'data-[state=unchecked]:[clip-path:inset(0_2px_0_0_round_9999px)] data-[state=unchecked]:rtl:[clip-path:inset(0_0_0_2px_round_9999px)]',
        'data-[state=checked]:[clip-path:inset(0_0_0_2px_round_9999px)] data-[state=checked]:rtl:[clip-path:inset(0_2px_0_0_round_9999px)]',
        'group-data-[hover-active]:[clip-path:inset(0_round_9999px)]'
      );
    case 'sm':
      return cn(
        'h-4 w-[19px]',
        'data-[state=checked]:translate-x-[13px] data-[state=checked]:rtl:translate-x-[-13px]',
        'data-[state=unchecked]:[clip-path:inset(0_3px_0_0_round_9999px)] data-[state=unchecked]:rtl:[clip-path:inset(0_0_0_3px_round_9999px)]',
        'data-[state=checked]:[clip-path:inset(0_0_0_3px_round_9999px)] data-[state=checked]:rtl:[clip-path:inset(0_3px_0_0_round_9999px)]',
        'group-data-[hover-active]:[clip-path:inset(0_round_9999px)]'
      );
    default:
      return cn(
        'h-5 w-[23px]',
        'data-[state=checked]:translate-x-[17px] data-[state=checked]:rtl:translate-x-[-17px]',
        'data-[state=unchecked]:[clip-path:inset(0_3px_0_0_round_9999px)] data-[state=unchecked]:rtl:[clip-path:inset(0_0_0_3px_round_9999px)]',
        'data-[state=checked]:[clip-path:inset(0_0_0_3px_round_9999px)] data-[state=checked]:rtl:[clip-path:inset(0_3px_0_0_round_9999px)]',
        'group-data-[hover-active]:[clip-path:inset(0_round_9999px)]'
      );
  }
};

export { switchVariants, thumbVariants };
